const formatTime = Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
}).format

const formatDate = Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
}).format

const valueToDate = (value) => {
    if (value === null || value === undefined) {
        return null;
    }

    if (value instanceof Date) {
        return value;
    }

    if (typeof value === 'number') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    const stringValue = `${value}`.trim();

    if (!stringValue) {
        return null;
    }

    const date = new Date(stringValue);
    return Number.isNaN(date.getTime()) ? null : date;
}

export const safeFormatTime = (value) => {
    const date = valueToDate(value);

    if (!date) {
        return value;
    }

    try {
        return formatTime(date);
    } catch (e) {
        console.error(e.message);
    }

    return value;
}

export const safeFormatDate = (value) => {
    const date = valueToDate(value);

    if (!date) {
        return value;
    }

    try {
        return formatDate(date);
    } catch (e) {
        console.error(e.message);
    }

    return value;
}